import React, { useState, useContext } from 'react';
import axios from 'axios';
import backendUrl from '../BackendUrl';
import { UserContext } from '../context/UserContext';
import '../styles/ContactUs.css'; // Reuse the same CSS

const RequestQuote = () => {
  const { user } = useContext(UserContext);

  const [vehicle, setVehicle] = useState('');
  const [notes, setNotes] = useState('');
  const [status, setStatus] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (!user) {
    return <div>Please sign in to request a quote.</div>;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setStatus('');
    try {
      const quoteRequest = {
        name: `${user.firstName} ${user.lastName}`,
        email: user.email,
        vehicle,
        notes,
        date: new Date().toISOString(),
      };
      await axios.post(`${backendUrl}/api/accounts/request-quote`, quoteRequest, {
        headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` }
      });
      setStatus('Your quote request has been sent. We will contact you soon!');
      setVehicle('');
      setNotes('');
    } catch (err) {
      setStatus('Failed to send quote request. Please try again later.');
    }
    setSubmitting(false);
  };

  return (
    <div className="contact-us-container">
      <h1>Request a Quote</h1>
      <form className="contact-form" onSubmit={handleSubmit}>
        <div>
          <label>Name:</label>
          <input type="text" value={`${user.firstName} ${user.lastName}`} disabled />
        </div>
        <div>
          <label>Email:</label>
          <input type="email" value={user.email} disabled />
        </div>
        <div>
          <label>Date/Time:</label>
          <input type="text" value={new Date().toLocaleString()} disabled />
        </div>
        <div>
          <label>Vehicle of Interest:</label>
          <input
            type="text"
            value={vehicle}
            onChange={e => setVehicle(e.target.value)}
            required
            placeholder="Vehicle model or class"
          />
        </div>
        <div>
          <label>Additional Notes:</label>
          <textarea
            value={notes}
            onChange={e => setNotes(e.target.value)}
            placeholder="Any specific requirements or questions?"
            rows={4}
          />
        </div>
        <button type="submit" disabled={submitting}>
          {submitting ? 'Sending...' : 'Request Quote'}
        </button>
        {status && <div className="contact-status">{status}</div>}
      </form>
    </div>
  );
};

export default RequestQuote;